import { AlertTriangle, RefreshCcw, Home, ArrowLeft } from "lucide-react"
import { useNavigate } from "react-router-dom"

type Props = {
  onRetry?: () => void
  message?: string
}

export function SomethingWentWrongPage({ onRetry, message }: Props) {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center bg-white p-8 rounded-2xl shadow-lg">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 p-3 rounded-full">
            <AlertTriangle className="w-8 h-8 text-red-600" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-xl font-semibold text-gray-800">
          Something went wrong
        </h1>

        {/* Message */}
        <p className="text-sm text-gray-500 mt-2">
          {message || "We encountered an unexpected issue. Please try again."}
        </p>

        {/* Actions */}
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          {/* Retry */}
          {onRetry && (
            <button
              onClick={onRetry}
              className="flex items-center gap-2 px-4 py-2 bg-gray-900 text-white rounded-lg text-sm"
            >
              <RefreshCcw className="w-4 h-4" />
              Retry
            </button>
          )}

          {/* Back */}
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>

          {/* Home */}
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm"
          >
            <Home className="w-4 h-4" />
            Home
          </button>
        </div>
      </div>
    </div>
  )
}
